// extracted by mini-css-extract-plugin
module.exports = {"item":"_1GB9t","title":"XVJKK","select":"_3-hS2"};